import type { SimpleTask } from 'Automations/nodeDefinitions/conductor'
import { parseTaskOutputReference } from '../parseTaskOutputReference'
import { stringValuesIn } from './stringValuesIn'

/**
 * The other tasks this one needs before it can run, found by looking at what its
 * `data` reads. We look inside nested objects and arrays too, because a single
 * entry can hold a whole set of references.
 *
 * The analysis and the fetching both go through here, so they always agree on
 * what depends on what. If they each had their own copy they could drift, and we
 * would end up asking for a task whose input we never filled in.
 */
export const getTaskDependencies = (task: SimpleTask): string[] => [
  ...new Set(
    stringValuesIn(task.inputParameters.data).reduce<string[]>((acc, value) => {
      const reference = parseTaskOutputReference(value)

      return reference.kind === 'task'
        ? [...acc, reference.taskReferenceName]
        : acc
    }, [])
  )
]
